var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.263 17.877h-8.53a.611.611 0 0 0-.609.609v.406c0 .335.274.61.61.61h8.529c.335 0 .61-.275.61-.61v-.406a.611.611 0 0 0-.61-.61zm0-3.25h-8.53a.611.611 0 0 0-.609.61v.406c0 .357.274.609.61.609h8.529c.335 0 .61-.252.61-.61v-.406a.611.611 0 0 0-.61-.609zm0-3.25h-8.53a.614.614 0 0 0-.609.623v.393c0 .335.274.607.61.607h8.529c.335 0 .61-.272.61-.607V12a.614.614 0 0 0-.61-.622zm3.046 12.998H2.687a.821.821 0 0 1-.812-.812V2.443c0-.443.365-.813.812-.813h8.936v5.28c0 .675.543 1.218 1.218 1.218h5.28v15.435a.821.821 0 0 1-.812.812zm.574-18.247a.72.72 0 0 1 .213.376h-4.849V1.655c.143.036.27.107.376.213zM19 5L14.77.716A2.467 2.467 0 0 0 13 0H2.687A2.442 2.442 0 0 0 .25 2.442v21.121A2.438 2.438 0 0 0 2.687 26h14.622a2.438 2.438 0 0 0 2.437-2.437V6.702c0-.645-.259-1.27-.746-1.702z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.4426e3c3c17d416b3466464033d85237.svg";
export { ForwardRef as ReactComponent };